import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeedViolation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.45 15.5C10.8667 15.9167 11.3917 16.1125 12.025 16.0875C12.6583 16.0625 13.1167 15.8333 13.4 15.4L19 7L10.6 12.6C10.1667 12.9 9.92917 13.3542 9.8875 13.9625C9.84583 14.5708 10.0333 15.0833 10.45 15.5ZM5.1 20C4.73333 20 4.39583 19.9208 4.0875 19.7625C3.77917 19.6042 3.53333 19.3667 3.35 19.05C2.91667 18.2667 2.58333 17.4542 2.35 16.6125C2.11667 15.7708 2 14.9 2 14C2 12.6167 2.2625 11.3167 2.7875 10.1C3.3125 8.88333 4.025 7.825 4.925 6.925C5.825 6.025 6.88333 5.3125 8.1 4.7875C9.31667 4.2625 10.6167 4 12 4C13.3667 4 14.65 4.25833 15.85 4.775C17.05 5.29167 18.1 5.99583 19 6.8875C19.9 7.77917 20.6167 8.82083 21.15 10.0125C21.6833 11.2042 21.9583 12.4833 21.975 13.85C21.9917 14.7667 21.8875 15.6625 21.6625 16.5375C21.4375 17.4125 21.0917 18.25 20.625 19.05C20.4417 19.3667 20.1958 19.6042 19.8875 19.7625C19.5792 19.9208 19.2417 20 18.875 20H5.1Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSpeedViolation);
export default ForwardRef;
